<template>
    <div>
        <news-list :articles="articlesLg" :max-columns="8" :columns-per-item="this.colsLg"
                   class="d-none d-lg-block"></news-list>
        <news-list :articles="articlesMd" :max-columns="12" :columns-per-item="this.colsMd"
                   class="d-none d-md-block d-lg-none"></news-list>
        <news-list :articles="articlesSm" :max-columns="12" :columns-per-item="this.colsSm"
                   class="d-block d-md-none"></news-list>
    </div>
</template>

<script>
    import NewsArticle from "./news-article";
    import NewsList from "./news-list";

    export default {
        components: { NewsList, NewsArticle },
        props: {
            results: {
                type: Array,
                required: true,
            },
        },
        data () {
            return {
                colsLg: 4,
                colsMd: 6,
                colsSm: 12,
            }
        },
        computed: {
            articlesLg () {
                return this.dividePerColumns(this.results, 12 / this.colsLg);
            },
            articlesMd () {
                return this.dividePerColumns(this.results, 12 / this.colsMd);
            },
            articlesSm () {
                return this.results.map(item => [item]);
            }
        },
        methods: {
            dividePerColumns (items, max) {
                const r = items.reduce((acc, item) => {
                    const lastItems = acc[acc.length - 1];
                    if (lastItems.length >= max || item.featured) {
                        if (lastItems.length === 0) lastItems.push(item);
                        else acc.push([item]);
                        if (item.featured) acc.push([]);
                    } else {
                        lastItems.push(item);
                    }
                    return acc;
                }, [[]]);
                return r;
            }
        }
    }
</script>
